import React, { useEffect, useRef, useState } from "react";
import axios, { AxiosResponse } from "axios";
import { DataTableWithoutButtons } from "components/DataTable/DataTableWithoutButtons";
import { AfDataType } from "utils/TableColumnData";
import handleWheel from "utils/handleOnWheel";
import { ListCommanWay, UpdateCommanWay } from "API/commonApi";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { Img } from "components";
import moment from "moment";
import Swal from "sweetalert2";
import UseToast from "utils/AfToast";
import Select from "react-select";
import { roles } from "utils/constant";
import { utils, write, writeFile } from "xlsx";
import { saveAs } from "file-saver";
import PrePickupNewGen from "./PrePickupNewGen";

const PrePickup: React.FC<any> = (props) => {
  const ADT = AfDataType;
  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const userD = (() => { const auth = localStorage.getItem("auth"); return auth ? JSON.parse(auth) : {}; })();
  const [userDetails, setUserDetails] = useState<any>(userD?.state?.user || {});

  const [tableData, setTableData] = useState<any>([]);
  const [tableDetails, setTableDetails] = useState<any>([]);

  const [startDate, setStartDate] = useState<any>(moment().subtract(1, "d").startOf("day").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState<any>(moment().endOf("day").format("YYYY-MM-DD"));
  const [query, setQuery] = useState<any>({
    createdAt: {
      $gte: moment(startDate).startOf("day"),
      $lte: moment(endDate).endOf("day"),
    },
  });
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [fetchedData, setFetchedData] = useState([]);
  const [isDataAdded, setIsDataAdded] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState({ id: undefined, name: "--- Select User ---" });
  const [allAgents, setAllAgents] = useState([]);

  const [activePickup, setActivePickup] = useState<any>({});

  useEffect(() => {
    const userD = (() => { const auth = localStorage.getItem("auth"); return auth ? JSON.parse(auth) : {}; })();
    if (Object.keys(userD).length) {
      setUserDetails(userD.state.user);
      if (userD.state.user.roleName == roles.SUPER_ADMIN) {
        mutateListAgents({ subbranch: undefined });
      } else if (userD.state.user.roleName == roles.SUBBRANCH_ADMIN) {
        mutateListAgents({ subbranch: userD.state.user?.subbranch });
      } else {
        mutateListAgents({ subbranch: undefined });
      }
    }
  }, []);
  const { mutate: mutateListAgents }: any = useMutation(
    (qry: any) => ListCommanWay("/admin/user/list", { subbranch: qry?.subbranch, isActive: true }, { paginate: 100000 }),
    {
      onSuccess: (data: any) => {
        if (data.status == "SUCCESS") {
          setAllAgents([{ id: undefined, name: "--- Select User ---" }, ...data.data.data]);
        }
      },
      onError: (data: any) => {},
    }
  );

  const handleSubmit = async () => {
    console.log("Ad");
    setIsDataAdded(!isDataAdded);
    setQuery({
      createdAt: {
        $gte: startDate ? startDate : moment().startOf("day").subtract(7, "days"),
        $lte: endDate ? moment(endDate).endOf("day") : moment().endOf("day"),
      },
    });
  };

  const { isFetching, isLoading, refetch } = useQuery(
    ["admin_prepickup_list"],
    () =>
      ListCommanWay("/admin/prepickup/list", query, {
        include: [],
        paginate: 10000,
        doSum: true,
      }),
    {
      keepPreviousData: true,
      enabled: false,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          console.log("data.data", data.data);
          let finalData = data.data.data;
          finalData.forEach((f) => {
            f.jsonData = JSON.parse(f?.jsonData || "[]");
          });
          console.log(finalData);
          setTableData(finalData);
          setTableDetails([]);
          
          //setActivePickup(finalData[0]);
        } else {
          setTableData([]);
        }
      },
      onError: (data) => {
        setTableData([]);
      },
    }
  );

  useEffect(() => {
    refetch();
  }, [query]);

  return (
    <>
      {activePickup?.id && <div className="absolute w-[98%] ml-[1%] bg-green-300 rounded-lg pb-4">
        <PrePickupNewGen prePickup={activePickup?.jsonData[0] || {}} />
      </div>}
      <h1 className="text-center mb-4 mt-3 text-lg font-semibold ">Request Pickup</h1>
      <div className="flex items-end flex-col gap-4 px-4  border-[1px] p-4 m-4 rounded-md">
        <div className="flex gap-1 items-center flex-wrap border p-2 rounded-xl bg-gray-200 border-blue-600 w-full">
          <div className="flex items-center ml-2 gap-4">
            <div className="flex gap-4 w-full flex-1 items-center">
              <label className=" text-sm font-semibold text-gray-900 whitespace-nowrap">From Date</label>
              <input
                type="date"
                className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-36 p-2.5`}
                placeholder="Start Date"
                name="startDate"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="flex gap-4 w-full flex-1 items-center">
              <label className="text-sm font-semibold text-gray-900 whitespace-nowrap">To Date</label>
              <input
                type="date"
                className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-36 p-2.5`}
                placeholder="End Date"
                name="endDate"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
          </div>

          <button
            type="button"
            onClick={handleSubmit}
            className="ml-2 rounded-md px-4 py-2 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
          >
            Search
          </button>
        </div>
      </div>
      <div>
        <table className="w-full table- mb-4 text-sm">
          <thead>
            <tr>
              <th className="border border-slate-200">System Date</th>
              <th className="border border-slate-200">Pickup Date</th>
              <th className="border border-slate-200">Customer code</th>
              <th className="border border-slate-200">Pickup City</th>
              <th className="border border-slate-200">No of pieces</th>
              <th className="border border-slate-200">Cgnee Company</th>
              <th className="border border-slate-200">CONTENT</th>
              <th className="border border-slate-200">Action</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((r, i) => {
              return (
                <tr key={`prePickup-${i}`} className={`${r.pay_status == "PAID" ? "bg-green-400" : ""} hover:bg-blue-100`}>
                  <td className="border border-slate-200 px-4 text-center whitespace-nowrap">
                    {moment(r.createdAt, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY")}
                  </td>
                  <td className="border border-slate-200 px-4 text-center whitespace-nowrap">{r.jsonData[0]?.DATE}</td>
                  <td className="border border-slate-200 px-4 text-center">{r.jsonData[0]?.["Customer code"]}</td>
                  <td className="border border-slate-200 px-4 text-center">{r.jsonData[0]?.["Pickup City"]}</td>
                  <td className="border border-slate-200 px-4 text-center">{r.jsonData[0]?.["No of pieces"]}</td>
                  <td className="border border-slate-200 px-4 text-center">{r.jsonData[0]?.["Consignee Company"]}</td>
                  <td className="border border-slate-200 px-4 text-center">{r.jsonData[0]?.["CONTENT"]}</td>

                  <td className="border border-slate-200 px-4 text-center">
                    {r.pay_status != "PAID" && (
                      <button
                        onClick={() => {
                          setActivePickup(r);
                        }}
                        className="rounded-md px-4 py-1 text-sm font-medium text-white bg-green-600 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 "
                      >
                        View
                      </button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PrePickup;
